// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tenant-payroll-setting.page.title': 'Payroll Settings',

    'tenant-payroll-setting.button.cancel': 'Cancel',
    'tenant-payroll-setting.button.save': 'Save Changes',

    'tenant-payroll-setting.success.message.tenant_payroll_settings_updated': 'Your payroll settings have been updated',

    'tenant-payroll-setting.error.message.error_loading_page': 'Sorry, there was an error loading payroll settings.',
};
